module.exports = "/static/js/15814fd71fff495debeb713fd0577ec2.png";